<h2 mat-dialog-title> {{ data.type == 'create' ? 'Nuevo ' + data.module : 'Actualización de ' + data.module }} </h2>
<mat-dialog-content class="mat-typography">

  <div class="input-item-form" [formGroup]="contractForm">
    @for (input of inputs; track input) {
      <div class="input-container">
        @if (input['type']) {
          <mat-form-field appearance="outline">
            <mat-label>{{ input['displayName'] }}</mat-label>
            <input matInput [type]="input['type']" [formControlName]="input['name']">
          </mat-form-field>
        }
      </div>
    }
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button (click)="data.type == 'create' ? createEntityData() : updateEntityData()"> Guardar </button>
</mat-dialog-actions>
